module.exports = __webpack_public_path__ + "img/2.5f465f4c.jpg";